"use strict";
/**************************************************************************************************
 *
 *      @file ./extend-kotlin-empty-list.ts
 *
 *      Polyfill to allow Kotlin EmptyList objects (and all inheriting Kotlin
 *      list object types) to provide their length when using them as if
 *      they're JS lists.
 *
 *      Prevents crashing if a length check is done on a Kotlin EmptyList or
 *      other type of atypical Kotlin list.
 *
 *      Polyfill is immediately applied on importing the file.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
var kotlin_1 = __importDefault(require("kotlin"));
var EmptyList = kotlin_1.default.kotlin.collections.EmptyList;
exports.KotlinEmptyList = EmptyList;
/******************************************** POLYFILL ********************************************/
/**
 * this.size is returned instead of 0 because EmptyList objects' methods get
 * inherited by other types of list objects that aren't necessarily empty.
 */
if (!EmptyList.length) {
    shared_1.defineGetter(EmptyList, 'length', function length() {
        return this.size;
    });
}
//# sourceMappingURL=extend-kotlin-empty-list.js.map